<template>
  <div class="resourceData-container">
    <div class="resourceData-frame">
      <!-- 选择器部分开始 -->
      <div class="selector-box flex">
        <!-- 课次选择器 -->
        <div class="classSelector flex align">
          <div class="selector-txt">课次</div>
          <el-select @change="classNumberHandleChange" v-model="classNumberValue" placeholder="请选择">
            <el-option v-for="item in classNumberOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!-- 班级选择器 -->
        <div class="flex align">
          <div class="selector-txt">班级</div>
          <el-cascader @change="classHandleChange" v-model="classValue" :options="classOptions"></el-cascader>
        </div>
      </div>
      <!-- 选择器部分结束 -->
      <!-- 主要内容部分开始 -->
      <div class="main-content flex">
        <!-- 教学实施部分开始 -->
        <div class="teachingImplementationPart">
          <div class="teachingImplementation-box flex align">
            <div class="teachingImplementation-block"></div>
            <div class="teachingImplementation-txt">教学实施</div>
          </div>
          <!-- 资源列表部分开始 -->
          <div class="resourceList">
            <!-- 课前准备部分 -->
            <div class="public-titleBox flex align spaceBetween">
              <div class="public-round"></div>
              <div class="public-title">课前准备</div>
            </div>
            <div>
              <div @click="resourcesDetails(item)"
                :class="currentResourcesId == item.link_id ? 'public-selectedBox pointer' : 'public-unselectedBox pointer'"
                v-for="(item, index) in beforeClassList" :key="index">
                <div class="public-border1"></div>
                <div class="public-txt">{{ item.name }}</div>
              </div>
            </div>
            <!-- 课堂教学部分 -->
            <div class="public-titleBox flex align spaceBetween">
              <div class="public-round"></div>
              <div class="public-title">课堂教学</div>
            </div>
            <div>
              <div @click="resourcesDetails(item)"
                :class="currentResourcesId == item.link_id ? 'public-selectedBox pointer' : 'public-unselectedBox pointer'"
                v-for="(item, index) in middleClassList" :key="index">
                <div class="public-border2"></div>
                <div class="public-txt">{{ item.name }}</div>
              </div>
            </div>
            <!-- 课后巩固部分 -->
            <div class="public-titleBox flex align spaceBetween">
              <div class="public-round"></div>
              <div class="public-title">课后巩固</div>
            </div>
            <div>
              <div @click="resourcesDetails(item)"
                :class="currentResourcesId == item.link_id ? 'public-selectedBox pointer' : 'public-unselectedBox pointer'"
                v-for="(item, index) in afterClassList" :key="index">
                <div class="public-border3"></div>
                <div class="public-txt">{{ item.name }}</div>
              </div>
            </div>
          </div>
          <!-- 资源列表部分结束 -->
        </div>
        <!-- 教学实施部分结束 -->
        <!-- 资源详情部分开始 -->
        <div v-show="detailsType != 'examPaper'" class="resourcesDetails-box">
          <!-- 资源展示面板部分开始 -->
          <div v-if="resourceDetails.typesOf == '资源'" class="flex spaceBetween">
            <div class="resourcesDetails-frame flex align justify">
              <el-image v-if="resourceDetails.types == '图片资源'" class="resourcesDetails-img" fit="cover"
                :src="resourceDetails.content[0]" :preview-src-list="resourceDetails.content"> </el-image>
              <video v-else-if="resourceDetails.types == '视频资源'" class="resourcesDetails-frame" controls
                :src="resourceDetails.content[0]"></video>
              <img v-else @click="viewResources" class="resourcesDetails-typeImg pointer"
                src="@/assets/documentResourcesIcon.png" />
            </div>
            <div class="resourcesDetails-detailsList flex column spaceBetween">
              <div class="flex">
                <div class="resourcesDetails-category">资源名称:</div>
                <div class="resourcesDetails-categoryValue">{{ resourceDetails.name }}</div>
              </div>
              <div class="flex">
                <div class="resourcesDetails-category">资源类型:</div>
                <div class="resourcesDetails-categoryValue">{{ resourceDetails.types }}</div>
              </div>
              <div class="flex">
                <div class="resourcesDetails-category">资源分值:</div>
                <div class="resourcesDetails-categoryValue">{{ resourceDetails.score }}分</div>
              </div>
              <div v-if="resourceDetails.types == '视频资源' || resourceDetails.types == '音频资源'" class="flex">
                <div class="resourcesDetails-category">得分设置:</div>
                <div class="resourcesDetails-categoryValue">观看{{ resourceDetails.percent }}%以上即可得分</div>
              </div>
              <div v-if="resourceDetails.types == '特殊互动' || resourceDetails.types == '资源链接'" class="flex">
                <div class="resourcesDetails-category">链接地址:</div>
                <a class="resourcesDetails-categoryValue" style="color: blue" target="_blank"
                  :href="resourceDetails.content[0]">{{ resourceDetails.content[0] }}</a>
              </div>
              <div class="flex">
                <div class="resourcesDetails-category">数据统计:</div>
                <div class="dataStatistics-box flex column spaceBetween">
                  <div class="flex align spaceBetween">
                    <div class="dataStatistics-txt">共查看次数</div>
                    <div class="dataStatistics-noProgressBar">
                      <div class="dataStatistics-progressBar" :style="`width: ${resourceDetails.totalViewPercentage}%`">
                      </div>
                    </div>
                    <div class="dataStatistics-txt txtWidth">{{ resourceDetails.totalView }}次</div>
                  </div>
                  <div class="flex align spaceBetween">
                    <div class="dataStatistics-txt">已查看人数</div>
                    <div class="dataStatistics-noProgressBar">
                      <div class="dataStatistics-progressBar"
                        :style="`width: ${resourceDetails.viewedPercentage}%; background: #1F96FA;`"></div>
                    </div>
                    <div class="dataStatistics-txt txtWidth">{{ resourceDetails.viewed }}人</div>
                  </div>
                  <div class="flex align spaceBetween">
                    <div class="dataStatistics-txt">未查看人数</div>
                    <div class="dataStatistics-noProgressBar">
                      <div class="dataStatistics-progressBar"
                        :style="`width: ${resourceDetails.notViewedPercentage}%; background: #F6C94F;`"></div>
                    </div>
                    <div class="dataStatistics-txt txtWidth">{{ resourceDetails.notViewed }}人</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 资源展示面板部分结束 -->
          <!-- 习题展示面板部分开始 -->
          <div v-if="resourceDetails.typesOf == '习题'">
            <div>
              <div class="flex spaceBetween">
                <div class="questionType">{{ resourceDetails.types }}</div>
                <div class="resourceDetails-scoreBox flex spaceBetween">
                  <div class="flex align">
                    <div class="score-txt">分值:</div>
                    <div class="score-inputFrame flex align justify">
                      <input v-model="resourceDetails.score" disabled class="score-input" type="text" />
                    </div>
                  </div>
                  <div class="flex">
                    <div class="score-txt">正确人数:</div>
                    <div class="score-completedPersonnel">{{ resourceDetails.completeNumber }}/{{ studentDataList.length
                      }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex spaceBetween">
              <div>
                <div class="score-txt">{{ resourceDetails.name }}</div>
                <div v-if="resourceDetails.types != '简答题'" class="option-box">
                  <div v-for="(item, index) in resourceDetails.options" :key="index" class="option-txt">{{
            optionOrder[index] }}.{{ item }}</div>
                </div>
                <div v-if="resourceDetails.types != '简答题'" class="topic-answer">答案：{{ resourceDetails.answer1 }}</div>
                <div class="topic-answer">解析：{{ resourceDetails.comment.replace(/<[^>]+>/g, "") }}</div>
              </div>
              <echartsPie :preData="preData[0]"></echartsPie>
            </div>
          </div>
          <!-- 习题展示面板部分结束 -->
          <!-- 作业展示面板开始 -->
          <div v-if="resourceDetails.typesOf == '作业'" class="exam-box flex spaceBetween">
            <div class="flex column spaceBetween">
              <div class="flex">
                <div class="resourcesDetails-category">作业名称:</div>
                <div class="resourcesDetails-categoryValue1">{{ resourceDetails.name }}</div>
              </div>
              <div class="flex">
                <div class="resourcesDetails-category">组卷方式:</div>
                <div class="resourcesDetails-categoryValue1">{{ resourceDetails.types }}组卷</div>
              </div>
              <div class="flex">
                <div class="resourcesDetails-category">作业题数:</div>
                <div class="resourcesDetails-categoryValue1">{{ resourceDetails.num_item }}道</div>
              </div>
              <div class="flex">
                <div class="resourcesDetails-category">作业满分:</div>
                <div class="resourcesDetails-categoryValue1">{{ resourceDetails.score }}分</div>
              </div>
            </div>
            <div class="flex column spaceBetween">
              <div class="dataStatistics-exam flex align spaceBetween">
                <div class="dataStatistics-examTxt">平均分</div>
                <div class="dataStatistics-noProgressBar">
                  <div class="dataStatistics-progressBar"
                    :style="`width: ${resourceDetails.averagePlan}%; background: #FA7369;`"></div>
                </div>
                <div class="dataStatistics-txt txtWidth">{{ resourceDetails.average }}分</div>
              </div>
              <div class="dataStatistics-exam flex align spaceBetween">
                <div class="dataStatistics-examTxt">完成率</div>
                <div class="dataStatistics-noProgressBar">
                  <div class="dataStatistics-progressBar"
                    :style="`width: ${resourceDetails.completionPlan}%; background: #1F96FA;`"></div>
                </div>
                <div class="dataStatistics-txt txtWidth">{{ resourceDetails.completionPlan }}%</div>
              </div>
              <div class="dataStatistics-exam flex align spaceBetween">
                <div class="dataStatistics-examTxt">完成人数</div>
                <div class="dataStatistics-noProgressBar">
                  <div class="dataStatistics-progressBar"
                    :style="`width: ${resourceDetails.completionPlan}%; background: #C9D656;`"></div>
                </div>
                <div class="dataStatistics-txt txtWidth">{{ resourceDetails.finishedNum }}人</div>
              </div>
              <div class="dataStatistics-exam flex align spaceBetween">
                <div class="dataStatistics-examTxt">部分完成人数</div>
                <div class="dataStatistics-noProgressBar">
                  <div class="dataStatistics-progressBar"
                    :style="`width: ${resourceDetails.partfinishedPlan}%; background: #F6C94F;`"></div>
                </div>
                <div class="dataStatistics-txt txtWidth">{{ resourceDetails.partfinishedNum }}人</div>
              </div>
              <div class="dataStatistics-exam flex align spaceBetween">
                <div class="dataStatistics-examTxt">未完成人数</div>
                <div class="dataStatistics-noProgressBar">
                  <div class="dataStatistics-progressBar"
                    :style="`width: ${resourceDetails.unfinishedPlan}%; background: #C490BF;`"></div>
                </div>
                <div class="dataStatistics-txt txtWidth">{{ resourceDetails.unfinishedNum }}人</div>
              </div>
            </div>
          </div>
          <!-- 作业展示面板结束 -->
          <!-- 学生表格数据部分开始 -->
          <el-table class="studentDataList" :data="studentDataList"
            :default-sort="{ prop: 'score', order: 'descending' }"
            :header-cell-style="{ background: '#EEEEEE', color: '#000000' }" stripe border
            height="calc(100vh - 3.5rem)">
            <el-table-column align="center" prop="name" label="学生姓名"> </el-table-column>
            <el-table-column align="center" prop="account" label="学号"> </el-table-column>
            <el-table-column align="center" prop="grade" label="年级"> </el-table-column>
            <el-table-column align="center" prop="class" label="班级"> </el-table-column>
            <el-table-column v-if="resourceDetails.typesOf == '资源' || resourceDetails.types == '简答题'" align="center"
              key="1" prop="completionStatus" label="完成情况"></el-table-column>
            <el-table-column v-if="resourceDetails.typesOf == '习题' && resourceDetails.types != '简答题'" align="center"
              prop="isItCorrect" label="是否正确"></el-table-column>
            <el-table-column v-if="resourceDetails.typesOf == '作业'" align="center" label="正确率">
              <template slot-scope="scope"> {{ scope.row.completedQuestionsNum }}题/{{ scope.row.completedQuestionsRate
                }}% </template>
            </el-table-column>
            <el-table-column sortable prop="score" align="center" label="得分">
              <template slot-scope="scope"> {{ scope.row.score }}分 </template>
            </el-table-column>
            <el-table-column v-if="resourceDetails.typesOf == '资源'" align="center" label="查看次数">
              <template slot-scope="scope"> {{ scope.row.numberOfViews }}次 </template>
            </el-table-column>
            <el-table-column v-if="resourceDetails.typesOf == '习题' || resourceDetails.typesOf == '作业'" align="center"
              label="答案">
              <template slot-scope="scope">
                <div v-show="resourceDetails.typesOf == '习题' && resourceDetails.types != '简答题'">
                  {{ scope.row.answer }}
                </div>
                <div v-show="resourceDetails.types == '简答题' || resourceDetails.typesOf == '作业'"
                  @click="answerDetail(scope)" class="answerDetail pointer">查看详情</div>
              </template>
            </el-table-column>
          </el-table>
          <!-- 学生表格数据部分结束 -->
          <!-- 查看作业按钮 -->
          <div v-if="resourceDetails.typesOf == '作业'" class="btnViewTestPaper-box flex justify">
            <div @click="btnViewTestPaper" class="btnViewTestPaper pointer flex align justify">查看作业</div>
          </div>
        </div>
        <!-- 资源详情部分结束 -->
        <!-- 作业详情部分开始 -->
        <div v-show="detailsType == 'examPaper'" class="examPaperDetails-box">
          <div v-for="(item, index) in viewTestPaperList" :key="index" class="testPaper-topicBox">
            <div class="flex spaceBetween">
              <div class="examPaperDetails-typeBox flex align spaceBetween" style="margin: 0">
                <div class="testPaper-topicNum">{{ index + 1 }}</div>
                <div class="testPaper-topicType">{{ item.typesName }}</div>
              </div>
              <div class="flex align spaceBetween" style="width: calc(100vw / 1920 * 431)">
                <div class="flex align">
                  <div class="score-txt">分值:</div>
                  <div class="score-inputFrame flex align justify">
                    <input v-model="item.score" disabled class="score-input" type="text" />
                  </div>
                </div>
                <div class="flex align">
                  <div class="score-txt">正确人数:</div>
                  <div class="score-txt" style="color: #349afe">{{ item.completedPersonnelNum }}/{{
            studentDataList.length }}
                  </div>
                </div>
                <img @click="btnDetail(item)" class="detailIcon pointer" src="@/assets/detailIcon.png" />
              </div>
            </div>
            <div class="flex spaceBetween">
              <div class="examPaperDetails-options">
                <div class="score-txt">{{ item.content.replace(/<[^>]+>/g, "") }}</div>
                <div v-if="item.typesName != '简答题'" class="option-box">
                  <div v-for="(item, index) in item.options" :key="index" class="option-txt">{{ optionOrder[index] }}.{{
            item }}
                  </div>
                </div>
                <div v-if="item.typesName != '简答题'" class="topic-answer">答案：{{ item.answer }}</div>
                <div class="topic-answer">解析：{{ item.comment.replace(/<[^>]+>/g, "") }}</div>
              </div>
              <echartsPie :preData="item.preData"></echartsPie>
            </div>
          </div>
        </div>
        <!-- 作业详情部分结束 -->
      </div>
      <!-- 主要内容部分结束 -->
    </div>
    <!-- 简答题查看详情弹窗部分开始 -->
    <div v-show="showPopupShortAnswer" class="popup-shortAnswer flex align justify">
      <div class="shortAnswer-content">
        <img @click="showPopupShortAnswer = false" class="btnClose pointer" src="../../assets/btnClose.png" />
        <!-- 姓名选择器 -->
        <div class="flex align">
          <div class="selector-txt">姓名</div>
          <el-select @change="nameHandleChange" filterable v-model="nameValue" placeholder="请选择">
            <el-option v-for="item in studentDataList" :key="item.account" :label="item.name" :value="item.account">
            </el-option>
          </el-select>
        </div>
        <div class="shortAnswer-typeBox flex align spaceBetween">
          <div class="questionType">简答题</div>
          <div class="flex align">
            <div class="score-txt">得分:</div>
            <div class="score-inputFrame flex align justify">
              <input v-model="studentScore" disabled class="score-input" type="text" />
            </div>
          </div>
        </div>
        <div class="shortAnswer-nameTxt">{{ resourceDetails.name }}</div>
        <div class="shortAnswer-answerBox">{{ studentAnswer }}</div>
        <!-- <div class="shortAnswer-analysis">解析：{{ resourceDetails.comment.replace(/<[^>]+>/g, "") }}</div> -->
        <div class="flex justify">
          <div @click="showPopupShortAnswer = false" class="btnConfirm flex align justify pointer">确认</div>
        </div>
      </div>
    </div>
    <!-- 简答题查看详情弹窗部分结束 -->
    <!-- 作业查看详情弹窗部分开始 -->
    <div v-show="showPopupTestPaper" class="popup-testPaper flex align justify">
      <div class="testPaper-content">
        <img @click="showPopupTestPaper = false" class="btnClose pointer" src="../../assets/btnClose.png" />
        <!-- 姓名选择器 -->
        <div class="flex align">
          <div class="selector-txt">姓名</div>
          <el-select @change="nameHandleChange" filterable v-model="nameValue" placeholder="请选择">
            <el-option v-for="item in studentDataList" :key="item.account" :label="item.name" :value="item.account">
            </el-option>
          </el-select>
        </div>
        <div class="testPaperList-box">
          <div v-for="(item, index) in viewTestPaperDetailsList" :key="index" class="testPaper-topicBox">
            <div class="flex spaceBetween">
              <div class="testPaper-typeBox flex align spaceBetween">
                <div class="testPaper-topicNum">{{ index + 1 }}</div>
                <div class="testPaper-topicType">{{ item.typesName }}</div>
              </div>
              <div class="flex align">
                <div class="score-txt">得分:</div>
                <div class="score-inputFrame flex align justify">
                  <!-- <input v-model="item.exam_item.getScore" disabled class="score-input" type="text" /> -->
                  {{ item.getScore || 0 }}
                </div>
              </div>
            </div>
            <div class="testPaper-options">
              <div class="score-txt">{{ item.content.replace(/<[^>]+>/g, "") }}</div>
              <div v-if="item.typesName != '简答题'" class="option-box">
                <div v-for="(item, index) in item.options" :key="index" class="option-txt">{{ optionOrder[index] }}.{{
            item
          }}</div>
              </div>
              <div v-if="item.typesName != '简答题'" class="topic-answer">答案：{{ item.answer }}</div>
              <div class="topic-answer">学生答案：{{ item.getAnswer }}</div>
              <div class="topic-answer">解析：{{ item.comment.replace(/<[^>]+>/g, "") }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 作业查看详情弹窗部分结束 -->
    <!-- 查看详情表格弹窗 -->
    <div v-show="showViewData" class="popup-viewData flex align justify">
      <img @click="showViewData = false" class="btnClose pointer" src="../../assets/btnClose.png" />
      <div class="viewData-content flex">
        <el-table :data="studentDataList" :header-cell-style="{ background: '#EEEEEE', color: '#000000' }" stripe border
          height="4rem">
          <el-table-column align="center" prop="name" label="学生姓名"> </el-table-column>
          <el-table-column align="center" prop="account" label="学号"> </el-table-column>
          <el-table-column align="center" prop="grade" label="年级"> </el-table-column>
          <el-table-column align="center" prop="class" label="班级"> </el-table-column>
          <el-table-column align="center" prop="isItCorrect" label="是否正确"> </el-table-column>
          <el-table-column align="center" label="得分">
            <template slot-scope="scope"> {{ scope.row.getScore }}分 </template>
          </el-table-column>
          <el-table-column align="center" prop="getAnswer" label="答案"> </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { obtainTeacherTeachingClass, resourceList, courseLearningRecords } from "@/api";
import echartsPie from "@/components/echarts_pie";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      classOptions: [], // 班级选项
      classValue: ["2021级", 1], // 默认班级
      classNumberOptions: [], // 课次选项
      classNumberValue: 0, // 默认课次
      combinedData: [], // 资源组合的数据
      beforeClassList: [], // 课前准备列表
      middleClassList: [], // 课堂教学列表
      afterClassList: [], // 课后巩固列表
      currentResourcesId: -1, // 当前选中的资源link_id
      studentDataList: [], // 学生表格数据
      resourceDetails: {}, // 资源详情
      testPaperList: [], // 作业列表
      viewTestPaperList: [], // 查看作业数据列表
      viewTestPaperDetailsList: [], // 查看作业详情列表
      preData: [
        {
          show: true,
          typeList: [
            { value: 0, name: "资源观看" },
            { value: 0, name: "观看时长" },
          ],
          countLength: "{totalText|共计}" + "\n" + "{totalText|" + 70 + "分}",
        },
      ],
      nameValue: "", // 默认姓名
      showPopupShortAnswer: false, // 是否展示简答题查看详情弹窗
      showPopupTestPaper: false, // 是否展示作业查看详情弹窗
      detailsType: "", // 详情类型
      studentScore: 0, // 学生得分
      studentAnswer: "", // 学生答案
      showViewData: false, // 作业查看详情弹窗
      testPaperTopic: {}, // 作业题目
      optionOrder: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
    };
  },
  components: { echartsPie },
  created() {
    // 调用获取老师授课班级列表接口
    let params1 = { lesson_id: this.$store.state.courseDetails.id };
    obtainTeacherTeachingClass(params1).then((res) => {
      let groupedData = res.data.datas.reduce((groups, item) => {
        (groups[item.grade] = groups[item.grade] || []).push(item);
        return groups;
      }, {});
      this.classValue[0] = res.data.datas[0].grade;
      this.classValue[1] = res.data.datas[0].id;
      this.classId = res.data.datas[0].id;
      for (let key in groupedData) {
        for (let j in groupedData[key]) {
          let publicRes = groupedData[key];
          publicRes[j].value = publicRes[j].id;
          publicRes[j].label = publicRes[j].name;
        }
        this.classOptions.push({
          value: key,
          label: key,
          children: groupedData[key],
        });
      }
      // 第一层按value从大到小排列
      this.classOptions.sort((a, b) => b.value.split("级")[0] - a.value.split("级")[0]);
      // 第二层的children按value从小到大排列
      this.classOptions.forEach(item => {
        if (item.children && Array.isArray(item.children)) {
          item.children.sort((a, b) => a.name.split("班")[0] - b.name.split("班")[0]);
        }
      });
    });
    // 获取当前课程全部课次的数据
    for (let i in this.$store.state.classListRecord) {
      this.classNumberValue = this.$store.state.classListRecord[0].id; // 默认课次选择器课次id
      // 获取课次选择器数据
      this.classNumberOptions.push({
        value: this.$store.state.classListRecord[i].id,
        label: this.$store.state.classListRecord[i].name,
      });
    }
    // 资源列表提交的参数
    let params = {
      lesson_id: this.$store.state.courseDetails.id,
      lesson_item_id: this.classNumberValue,
      types: "",
      page: 1,
      num: 1000,
    };
    // 调用获取数据方法
    this.publicClassResources(params);
  },
  methods: {
    // 获取数据方法
    publicClassResources(params) {
      this.combinedData = []; // 清空资源列表数据
      this.studentDataList = []; // 清空学生数据列表数据
      resourceList(params).then((res) => {
        for (let i in res.data.datas) {
          // 获取列表数据
          if (res.data.datas[i].assets) {
            let publicRes = res.data.datas[i].assets;
            publicRes.typesOf = "资源";
            publicRes.link_id = res.data.datas[i].id;
            // this.resourceList.push(res.data.datas[i].assets);
            // this.resourceList.push(res.data.datas[i].exam_item);
            // this.resourceList.push(res.data.datas[i].exam);
            publicRes.score = publicRes.score + "分"; // 转换分数格式
            if (publicRes.types == "video") {
              publicRes.types = "视频资源";
            } else if (publicRes.types == "audio") {
              publicRes.types = "音频资源";
            } else if (publicRes.types == "doc") {
              publicRes.types = "文档资源";
            } else if (publicRes.types == "image") {
              publicRes.types = "图片资源";
            } else if (publicRes.types == "web") {
              publicRes.types = "资源链接";
            } else if (publicRes.types == "h5") {
              publicRes.types = "特殊互动";
            }
            this.combinedData.push(res.data.datas[i].assets);
          } else if (res.data.datas[i].exam_item) {
            let publicRes = res.data.datas[i].exam_item;
            publicRes.typesOf = "习题";
            publicRes.link_id = res.data.datas[i].id;
            publicRes.name = publicRes.content.replace(/<[^>]+>/g, ""); // 转换名字格式
            if (publicRes.types == "single") {
              publicRes.types = "单选题";
            } else if (publicRes.types == "multi") {
              publicRes.types = "多选题";
            } else if (publicRes.types == "truefalse") {
              publicRes.types = "判断题";
            } else if (publicRes.types == "answer") {
              publicRes.types = "简答题";
            }
            this.combinedData.push(res.data.datas[i].exam_item); // 将资源和试题两个接口的数据整合成一个数组
          } else if (res.data.datas[i].exam) {
            let publicRes = res.data.datas[i].exam;
            publicRes.typesOf = "作业";
            publicRes.link_id = res.data.datas[i].id;
            publicRes.created = res.data.datas[i].created.substring(0, 10); // 转换日期格式
            publicRes.score = publicRes.score + "分"; // 转换分数格式
            if (publicRes.types == "manual") {
              publicRes.types = "手动";
            } else if (publicRes.types == "auto") {
              publicRes.types = "自动";
            }
            this.combinedData.push(res.data.datas[i].exam); // 作业数据获取
          }
          // xiu.push(res.data.datas[i].assets);
        }
        this.beforeClassList = [];
        this.middleClassList = [];
        this.afterClassList = [];
        // console.log(this.combinedData.length);
        for (let i in this.combinedData) {
          // console.log(i, this.combinedData[i].usage);
          if (this.combinedData[i].usage == "front") {
            this.beforeClassList.push(this.combinedData[i]); // 课前准备数据获取
          } else if (this.combinedData[i].usage == "middle") {
            this.middleClassList.push(this.combinedData[i]); // 课堂教学数据获取
          } else if (this.combinedData[i].usage == "back") {
            this.afterClassList.push(this.combinedData[i]); // 课后巩固数据获取
          }
        }
        // console.log("所有资源数据", this.combinedData);
        // console.log("课前准备数据:", this.beforeClassList);
        // console.log("课堂教学数据:", this.middleClassList);
        // console.log("课后巩固数据:", this.afterClassList);
        this.publicGettingDataFunc(); // 获取全部学生表格数据
      });
    },
    //获取作业详情面板数据
    getPaperDetail(resource, student) {
      let { count, average, averagePlan, score, completionPlan, finishedNum, partfinishedNum, partfinishedPlan, unfinishedNum, unfinishedPlan } = resource;
      // 计算作业平均分
      average = (count / student.length).toFixed(1);
      // 计算作业平均分进度条占比
      averagePlan = ((average / score) * 100).toFixed(1);
      // 计算作业完成率或完成人数占比
      completionPlan = ((finishedNum / student.length) * 100).toFixed(1);
      // 计算部分完成人数进度条占比
      partfinishedPlan = ((partfinishedNum / student.length) * 100).toFixed(1);
      // 计算未完成人数进度条占比
      unfinishedPlan = ((unfinishedNum / student.length) * 100).toFixed(1);
      return { ...resource, average, averagePlan, completionPlan, partfinishedPlan, unfinishedPlan };
    },
    // 获取学生表格数据
    publicGettingDataFunc() {
      this.studentDataList = []; // 清空学生数据列表数据
      this.viewTestPaperList = []; // 清空查看作业数据列表
      this.viewTestPaperDetailsList = []; // 清空查看作业详情列表
      this.preData = [];
      let resourceDetails = JSON.parse(JSON.stringify(this.resourceDetails)); // 资源详情
      resourceDetails.answer1 = []; // 获取转换后的答案
      let { types, options, answer, typesOf } = resourceDetails;
      let topicLog = []; // echarts图表选项的值
      this.preData.push({
        show: true,
        typeList: [],
        countLength: `{totalText|${types != "简答题" ? "正确率" : "完成率"}}\n{totalText|0%}`,
      });
      if (types != "简答题") {
        for (let j in options) {
          this.preData[0].typeList.push({ value: 0, name: this.optionOrder[j] });
        }
        if (types == "判断题") resourceDetails.options = ["正确", "错误"];
        if (typesOf == "习题" || types == "判断题") resourceDetails.answer1 = answer.map((item) => this.optionOrder[item]).join("、");
      } else {
        this.preData[0].typeList.push({ value: 0, name: "已完成" }, { value: 0, name: "未完成" });
      }
      // 调用获取课次习题学生记录列表接口
      let params = { lesson_id: this.$store.state.courseDetails.id, class_id: this.classValue[1], types: "" };
      courseLearningRecords(params).then((res) => {
        let sourceList = res.data; // 源数据
        let extData = sourceList.ext; // 扩展数据
        let topicList = sourceList.datas; // 题目数据
        let answerList = extData.lesson_user; // 答题记录
        let studentList = extData.users; //学生列表
        let studentTable = {}; // 学生表格数据
        if (typesOf == "资源") {
          // 筛选当前班级学生资源学习记录
          const resourceRecordList = answerList.filter(({ link_type, link_resource_id }) => link_type == "assets" && resourceDetails.link_id == link_resource_id);
          // console.log("当前班级学生资源学习记录", resourceRecordList);
          /**
           * 学生表格数据处理
           */
          let { grade: extDataGrade, name: extDataName } = extData.class;
          for (let i = 0; i < studentList.length; i++) {
            let { account, name } = studentList[i];
            studentTable[account] = { account, name, grade: extDataGrade, class: extDataName, completionStatus: "未完成", score: 0, numberOfViews: 0 };
          }
          resourceRecordList.forEach(({ user_account, score, num }) => {
            // 获取每个学生资源得分
            studentTable[user_account].score = score;
            // 获取每个学生查看次数
            studentTable[user_account].numberOfViews = num;
            // 获取每个学生的完成情况
            if (studentTable[user_account].score == resourceDetails.score) {
              studentTable[user_account].completionStatus = "已完成";
            } else {
              studentTable[user_account].completionStatus = "未完成";
            }
            // 获取资源详情面板共查看次数
            resourceDetails.totalView += num;
            // 获取资源详情面板已查看人数
            resourceDetails.viewed++;
          });
          /**
           * 数据面板处理
           */
          // 获取资源详情面板共查看次数占比
          if (resourceDetails.totalView > 0) resourceDetails.totalViewPercentage = 100;
          // 获取资源详情面板已查看人数占比
          resourceDetails.viewedPercentage = Math.floor((resourceDetails.viewed / studentList.length) * 100);
          // 获取资源详情面板未查看人数
          resourceDetails.notViewed = studentList.length - resourceDetails.viewed;
          // 获取资源详情面板未查看人数占比
          resourceDetails.notViewedPercentage = Math.floor((resourceDetails.notViewed / studentList.length) * 100);
          // 给学生表格数据赋值
          let studentDataList = [];
          for (let key in studentTable) {
            studentDataList.push(studentTable[key]);
          }
          this.studentDataList = studentDataList;
          // 给数据面板数据赋值
          this.resourceDetails = resourceDetails;
          // console.log(this.resourceDetails);
        } else if (typesOf == "习题") {
          this.preData = [];
          this.preData.push({
            show: true,
            typeList: [],
            countLength: `{totalText|${types != "简答题" ? "正确率" : "完成率"}}\n{totalText|0%}`,
          });
          if (types != "简答题") {
            for (let j in options) {
              this.preData[0].typeList.push({ value: 0, name: this.optionOrder[j] });
            }
            if (types == "判断题") resourceDetails.options = ["正确", "错误"];
            if (typesOf == "习题" || types == "判断题") resourceDetails.answer1 = answer.map((item) => this.optionOrder[item]).join("、");
          } else {
            this.preData[0].typeList.push({ value: 0, name: "已完成" }, { value: 0, name: "未完成" });
          }
          // 筛选当前班级学生习题学习记录
          const exercisesRecordList = answerList.filter(({ link_type, link_resource_id }) => link_type == "examitem" && resourceDetails.link_id == link_resource_id);
          // console.log("当前班级学生习题学习记录", exercisesRecordList);
          /**
           * 学生表格数据处理
           */
          let { grade: extDataGrade, name: extDataName } = extData.class;
          for (let i = 0; i < studentList.length; i++) {
            let { account, name } = studentList[i];
            studentTable[account] = { account, name, grade: extDataGrade, class: extDataName, isItCorrect: "未作答", score: 0, answer: "", completionStatus: "未完成" };
          }
          exercisesRecordList.forEach(({ user_account, score, answer }) => {
            // 获取每个学生习题得分
            studentTable[user_account].score = score;
            // 获取每个学生是否正确
            if (types != "简答题") {
              // 获取每个学生习题答案
              studentTable[user_account].answer = answer
                .split(",")
                .map((item) => this.optionOrder[item])
                .join("、");
              if (!studentTable[user_account].answer) {
                studentTable[user_account].isItCorrect = "未作答";
              } else if (studentTable[user_account].score) {
                studentTable[user_account].isItCorrect = "正确";
                // 获取习题详情面板正确人数
                resourceDetails.completeNumber++;
              } else {
                studentTable[user_account].isItCorrect = "错误";
              }
              // 获取答题记录
              topicLog.push(answer);
              let countObj = {};
              let arrayNum = topicLog.join(",").split(",").filter(Boolean).map(Number);
              for (let i = 0; i < arrayNum.length; i++) {
                let num = arrayNum[i];
                if (countObj[num]) {
                  // 如果对象中已存在该数，则计数加一
                  countObj[num] += 1;
                } else {
                  // 如果对象中不存在该数，则创建新的键，并设置计数为一
                  countObj[num] = 1;
                }
              }
              // 获取echart的数据
              this.preData = [];
              this.preData.push({
                show: true,
                typeList: [],
                countLength: "{totalText|正确率}" + "\n" + "{totalText|" + Math.floor((resourceDetails.completeNumber / studentList.length) * 100) + "%}",
              });
              for (let j in this.resourceDetails.options) {
                this.preData[0].typeList.push({
                  value: countObj[j] || 0,
                  name: this.optionOrder[j],
                });
              }
            } else {
              // 获取每个学生习题答案
              studentTable[user_account].answer = answer;
              // 获取每个学生完成情况
              if (studentTable[user_account].score) {
                studentTable[user_account].completionStatus = "已完成";
                // 获取习题详情面板正确人数
                resourceDetails.completeNumber++;
                this.preData[0].typeList[0].value = resourceDetails.completeNumber;
                this.preData[0].typeList[1].value = studentList.length - resourceDetails.completeNumber;
                this.preData[0].countLength = `{totalText|${types != "简答题" ? "正确率" : "完成率"}}\n{totalText|${((resourceDetails.completeNumber / studentList.length) * 100).toFixed(1)}%}`;
              }
            }
          });
          // 给学生表格数据赋值
          let studentDataList = [];
          for (let key in studentTable) {
            studentDataList.push(studentTable[key]);
          }
          this.studentDataList = studentDataList;
          // 给数据面板数据赋值
          this.resourceDetails = resourceDetails;
        } else if (typesOf == "作业") {
          // 筛选当前班级学生作业答题数据
          const paperRecordList = answerList.filter(({ link_type, link_resource_id, link_exam_item_id }) => link_type == "exam" && resourceDetails.link_id == link_resource_id && link_exam_item_id);
          /**
           * 作业题目数据处理
           */
          // 所有试题
          let volidPaperList = topicList.filter(({ id }) => resourceDetails.link_id == id)[0]?.exam?.exam_items;
          // // let volidPaperList = topicList.filter(({ id }) => resourceDetails.link_id == id);
          // console.log(topicList, resourceDetails, volidPaperList);
          // 试题类型
          let typesList = { single: "单选题", multi: "多选题", truefalse: "判断题", answer: "简答题" };
          // 试题数据
          let testPaperTable = {};
          if (volidPaperList) {
            for (let i = 0; i < volidPaperList.length; i++) {
              let { id: link_id, score, exam_item } = volidPaperList[i];
              let { content, comment, options, types: examTypes, answer } = exam_item;
              testPaperTable[link_id] = { link_id, content, comment, options, score, typesName: typesList[examTypes], completedPersonnelNum: 0, answer: answer.map((item) => this.optionOrder[item]).join("、"), preData: {}, record: [], getScore: 0, getAnswer: "" };
            }
          }
          // 选项正确人数
          paperRecordList.forEach(({ user_account, link_exam_item_id, score, answer, assets_type }) => {
            let { score: paperScore } = testPaperTable[link_exam_item_id];
            if (score == paperScore) testPaperTable[link_exam_item_id].completedPersonnelNum++;
            testPaperTable[link_exam_item_id].record.push({ user_account, answer, score, assets_type });
          });
          let testPaperDataList = [];
          for (let key in testPaperTable) {
            let { typesName, record, options } = testPaperTable[key];
            // echarts数据
            let preData = {
              show: true,
              typeList: [],
            };
            // 每道题的正确率
            let accuracy = Math.floor((testPaperTable[key].completedPersonnelNum / studentList.length) * 100);
            // 每个选项的被选择数
            if (typesName == "简答题") {
              let answerNum = record.filter((item) => item.score); // 简答题完成数量
              preData.typeList.push({ value: answerNum, name: "已完成" }, { value: studentList.length - answerNum, name: "未完成" });
            } else {
              let list = []; // 选择题、判断题、多选题的选项列表
              let group = record
                .map((item) => item.answer.split(","))
                .reduce((acc, val) => acc.concat(val), [])
                .filter((item) => item && item != "-1")
                .reduce((acc, val) => {
                  if (!acc[val]) {
                    acc[val] = [];
                  }
                  acc[val].push(val);
                  return acc;
                }, {});
              for (let i = 0; i < options.length; i++) {
                list.push({ value: group[i]?.length || 0, name: this.optionOrder[i] });
              }
              preData.typeList = list;
            }
            // 正确率
            preData.countLength = `{totalText|${typesName != "简答题" ? "正确率" : "完成率"}}\n{totalText|${accuracy}%}`;
            testPaperTable[key].preData = preData;
            testPaperDataList.push(testPaperTable[key]);
          }
          this.testPaperList = testPaperDataList; // 获取作业数据列表
          /**
           * 学生表格数据处理
           */
          let { grade: extDataGrade, name: extDataName } = extData.class;
          for (let i = 0; i < studentList.length; i++) {
            let { account, name } = studentList[i];
            studentTable[account] = { account, name, grade: extDataGrade, class: extDataName, score: 0, completedQuestionsNum: 0, completedQuestionsRate: 0, isItCorrect: "未作答", getScore: 0, getAnswer: "" };
          }
          paperRecordList.forEach((item) => {
            // 获取每个学生作业得分
            studentTable[item.user_account].score += item.score;
            // 获取每个学生作业完成题数
            if (item.score == item.score_full) studentTable[item.user_account].completedQuestionsNum++;
            // 获取作业详情面板所有学生的作业总分
            resourceDetails.count += item.score;
          });
          // 给学生表格数据赋值
          let studentDataList = [];
          for (let key in studentTable) {
            // 获取每个学生的作业正确率
            studentTable[key].completedQuestionsRate = Math.floor((studentTable[key].completedQuestionsNum / resourceDetails.num_item) * 100);
            if (studentTable[key].completedQuestionsNum == resourceDetails.num_item) {
              resourceDetails.finishedNum++;
            } else if (studentTable[key].completedQuestionsNum) {
              resourceDetails.partfinishedNum++;
            } else {
              resourceDetails.unfinishedNum++;
            }
            studentDataList.push(studentTable[key]);
          }
          this.studentDataList = studentDataList;
          // 给数据面板数据赋值
          resourceDetails = this.getPaperDetail(resourceDetails, studentDataList);
          this.resourceDetails = resourceDetails;
        }
      });
    },
    // 获取资源详情
    resourcesDetails(item) {
      this.detailsType = "";
      if (item.types == "特殊互动" || item.types == "资源链接") {
        if (item.content[0].indexOf("?") != -1) {
          item.content[0] = item.content[0] + "&no=" + this.classNumberValue + "&token=" + this.$store.state.tokenCode;
        } else {
          item.content[0] = item.content[0] + "?no=" + this.classNumberValue + "&token=" + this.$store.state.tokenCode;
        }
      }
      if (String(item.score).includes("分")) {
        item.score = parseInt(item.score.replace(/分$/, ""), 10);
      }
      this.currentResourcesId = item.link_id; // 获取当前资源的link_id
      this.resourceDetails = item;
      if (this.resourceDetails.typesOf == "资源") {
        this.addAttribute("资源");
      } else if (this.resourceDetails.typesOf == "习题") {
        item.answer1 = []; // 获取转换后的答案
        this.addAttribute("习题");
      } else if (this.resourceDetails.typesOf == "作业") {
        this.addAttribute("作业");
      }
      this.publicGettingDataFunc(); // 获取全部学生表格数据
    },
    // 添加属性
    addAttribute(type) {
      if (type == "资源") {
        this.resourceDetails = {
          ...this.resourceDetails,
          totalView: 0, // 共查看次数
          viewed: 0, // 已查看人数
          notViewed: 0, // 未查看人数
          totalViewPercentage: 0, // 共查看次数占比
          viewedPercentage: 0, // 已查看人数占比
          notViewedPercentage: 0, // 未查看人数占比
        };
      } else if (type == "习题") {
        this.resourceDetails = {
          ...this.resourceDetails,
          completeNumber: 0, // 习题正确人数
        };
      } else if (type == "作业") {
        this.resourceDetails = {
          ...this.resourceDetails,
          count: 0, // 学生作业总分
          average: 0, // 平均分
          averagePlan: 0, // 平均分占比
          finishedNum: 0, // 完成人数
          completionPlan: 0, // 完成率
          unfinishedNum: 0, // 未完成人数
          partfinishedNum: 0, // 部分完成人数
          partfinishedPlan: 0, // 部分完成人数占比
        };
      }
    },
    // 班级选择器
    classHandleChange(value) {
      this.detailsType = "";
      this.addAttribute(this.resourceDetails.typesOf);
      this.classValue[1] = value[1]; // 获取班级id
      this.publicGettingDataFunc(); // 调用获取数据方法
    },
    // 课次选择器
    classNumberHandleChange(value) {
      this.addAttribute(this.resourceDetails.typesOf);
      // 资源列表提交的参数
      let params = {
        lesson_id: this.$store.state.courseDetails.id,
        lesson_item_id: value,
        types: "",
        page: 1,
        num: 1000,
      };
      // 调用获取数据方法
      this.publicClassResources(params);
    },
    // 姓名选择器
    nameHandleChange(value) {
      this.nameValue = value; // 获取学生账号
      // this.addAttribute(this.resourceDetails.typesOf);
      if (this.resourceDetails.types == "简答题") {
        let answerRecord = this.studentDataList.filter(({ account }) => account == value);
        this.studentAnswer = answerRecord[0].answer; // 获取学生简答题答案
        this.studentScore = answerRecord[0].score; // 获取学生简答题分数
      } else if (this.resourceDetails.typesOf == "作业") {
        this.viewTestPaperDetailsList = this.testPaperList; // 获取查看作业详情列表
        for (let i in this.viewTestPaperDetailsList) {
          let publicPrefix = this.viewTestPaperDetailsList[i];
          publicPrefix.studentRecord = publicPrefix.record.filter(({ user_account }) => user_account == value);
          if (publicPrefix.studentRecord.length != 0) {
            publicPrefix.getScore = publicPrefix.studentRecord[0].score;
            publicPrefix.getAnswer = publicPrefix.studentRecord[0].answer
              .split(",")
              .map((item) => this.optionOrder[item])
              .join("、");
          } else {
            publicPrefix.getScore = 0;
            publicPrefix.getAnswer = "";
          }
        }
      }
    },
    // 作业答案查看详情
    answerDetail(data) {
      this.nameValue = data.row.account; // 获取姓名
      // this.addAttribute(this.resourceDetails.typesOf);
      this.studentScore = data.row.score; // 获取学生分数
      this.studentAnswer = data.row.answer; // 获取学生简答题答案
      if (this.resourceDetails.types == "简答题") {
        this.showPopupShortAnswer = true;
      } else if (this.resourceDetails.typesOf == "作业") {
        this.showPopupTestPaper = true;
        this.viewTestPaperDetailsList = this.testPaperList; // 获取查看作业详情列表
        for (let i in this.viewTestPaperDetailsList) {
          let publicPrefix = this.viewTestPaperDetailsList[i];
          publicPrefix.studentRecord = publicPrefix.record.filter(({ user_account }) => user_account == data.row.account);
          if (publicPrefix.studentRecord.length != 0) {
            publicPrefix.getScore = publicPrefix.studentRecord[0].score;
            if (publicPrefix.studentRecord[0].assets_type == "answer") {
              publicPrefix.getAnswer = publicPrefix.studentRecord[0].answer;
            } else {
              publicPrefix.getAnswer = publicPrefix.studentRecord[0].answer
                .split(",")
                .map((item) => this.optionOrder[item])
                .join("、");
            }
          }
        }
      }
    },
    // 查看作业
    btnViewTestPaper() {
      this.detailsType = "examPaper";
      this.viewTestPaperList = this.testPaperList; // 获取查看作业数据列表
      this.addAttribute(this.resourceDetails.typesOf);
    },
    // 查看作业=>查看详情
    btnDetail(data) {
      this.testPaperTopic = data; // 获取作业题目
      this.showViewData = true;
      // 作业查看详情表格是否正确
      let linkList = this.testPaperList.filter((item) => item.link_id == data.link_id);
      for (let i in this.studentDataList) {
        for (let j in linkList[0].record) {
          if (this.studentDataList[i].account == linkList[0].record[j].user_account) {
            this.studentDataList[i].getScore = linkList[0].record[j].score; // 获取作业查看详情分数
            if (linkList[0].record[j].assets_type == "answer") {
              this.studentDataList[i].getAnswer = linkList[0].record[j].answer; // 获取作业查看详情答案
            } else {
              this.studentDataList[i].getAnswer = linkList[0].record[j].answer // 获取作业查看详情答案
                .split(",")
                .map((item) => this.optionOrder[item])
                .join("、");
            }
          }
        }
        if (data.typesName == "简答题") {
          if (this.studentDataList[i].getAnswer == "") {
            this.studentDataList[i].isItCorrect = "未作答";
          } else {
            this.studentDataList[i].isItCorrect = "已作答";
          }
        } else {
          if (this.studentDataList[i].getAnswer == "") {
            this.studentDataList[i].isItCorrect = "未作答";
          } else if (this.studentDataList[i].getScore == linkList[0].score) {
            this.studentDataList[i].isItCorrect = "正确";
          } else {
            this.studentDataList[i].isItCorrect = "错误";
          }
        }
      }
    },
    // 查看资源
    viewResources() {
      window.open(this.resourceDetails.content[0]);
    },
  },
};
</script>

<style lang="scss" scoped>
.resourceData-container {
  height: calc(100% - 87px);
}

.resourceData-frame {
  height: calc(100% - 87px);
  width: 1740px;
  background: #ffffff;
}

.selector-box {
  margin-top: 10px;
  margin-left: 40px;
  box-sizing: border-box;
}

.classSelector {
  margin-left: 50px;
}

.selector-txt {
  margin-right: 13px;
  font-size: 24px;

  font-weight: 400;
  color: #000000;
}

.main-content {
  margin-top: 30px;
  height: 100%;
}

.teachingImplementationPart {
  width: 466px;
  height: 100%;
  border-right: 1px solid #bfbfbf;
}

.teachingImplementation-box {
  height: 60px;
  background: rgb(52, 154, 254, 0.25);
}

.teachingImplementation-block {
  margin-left: 20px;
  width: 12px;
  height: 26px;
  background: #3096fb;
}

.teachingImplementation-txt {
  margin-left: 20px;
  font-size: 24px;

  font-weight: 400;
  color: #000000;
  line-height: 24px;
}

.resourceList {
  height: calc(100% - 45px);
  overflow: auto;
}

.public-titleBox {
  height: 50px;
  background: #eaeaea;
  padding: 16px 323px 15px 31px;
  box-sizing: border-box;
}

.public-titleBox:first-child {
  margin-top: 2px;
  height: 50px;
  background: #eaeaea;
  padding: 16px 323px 15px 31px;
  box-sizing: border-box;
}

.public-round {
  width: 10px;
  height: 10px;
  background: #3096fb;
  border-radius: 50%;
}

.public-title {
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 18px;
}

.public-selectedBox {
  position: relative;
  height: 52px;
  background: #c4e6cd;
}

.public-unselectedBox {
  position: relative;
  height: 52px;
}

.public-border1 {
  position: absolute;
  bottom: 1px;
  width: 406px;
  height: 1px;
  background: #bfbfbf;
  left: 50%;
  transform: translateX(-50%);
}

.public-selectedBox:last-child .public-border1 {
  position: absolute;
  bottom: 1px;
  height: 0px;
}

.public-unselectedBox:last-child .public-border1 {
  position: absolute;
  bottom: 1px;
  height: 0px;
}

.public-border2 {
  position: absolute;
  bottom: 1px;
  width: 406px;
  height: 1px;
  background: #bfbfbf;
  left: 50%;
  transform: translateX(-50%);
}

.public-selectedBox:last-child .public-border2 {
  position: absolute;
  bottom: 1px;
  height: 0px;
}

.public-unselectedBox:last-child .public-border2 {
  position: absolute;
  bottom: 1px;
  height: 0px;
}

.public-border3 {
  position: absolute;
  bottom: 1px;
  width: 406px;
  height: 1px;
  background: #bfbfbf;
  left: 50%;
  transform: translateX(-50%);
}

.public-selectedBox:last-child .public-border3 {
  position: absolute;
  bottom: 1px;
  height: 0px;
}

.public-unselectedBox:last-child .public-border3 {
  position: absolute;
  bottom: 1px;
  height: 0px;
}

.public-txt {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 50px;
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 50px;
  width: 366px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.resourcesDetails-box {
  width: 1273px;
  height: calc(100%);
  padding: 0 40px 33px 40px;
  box-sizing: border-box;
}

.resourcesDetails-frame {
  width: 500px;
  height: 281px;
  background: #ffffff;
  border: 1px solid #757575;
  border-radius: 10px;
}

.resourcesDetails-typeImg {
  width: 242px;
  height: 243px;
}

.resourcesDetails-detailsList {
  width: 653px;
  height: 280px;
}

.resourcesDetails-category {
  font-size: 18px;

  font-weight: 400;
  color: #3096fb;
  line-height: 18px;
}

.resourcesDetails-categoryValue {
  width: 541px;
  margin-left: 28px;
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.resourcesDetails-categoryValue1 {
  width: 500px;
  margin-left: 28px;
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataStatistics-box {
  margin-left: 28px;
  width: 541px;
  height: 99px;
}

.dataStatistics-txt {
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 20px;
}

.dataStatistics-examTxt {
  width: 111px;
  height: 20px;
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 20px;
  text-align: justify;
  text-align-last: justify;
}

.dataStatistics-examTxt::after {
  content: "";
  display: inline-block;
  padding-left: 100%;
  margin-left: 100%;
}

.dataStatistics-noProgressBar {
  width: 357px;
  height: 14px;
  background: #eaeaea;
  border-radius: 3px;
}

.dataStatistics-progressBar {
  height: 14px;
  background: #fa7369;
  border-radius: 3px;
}

.studentDataList {
  height: 350px;
  margin-top: 30px;
}

.exam-box {
  height: 192px;
}

.dataStatistics-exam {
  width: 576px;
}

.btnViewTestPaper-box {
  margin-top: 25px;
}

.btnViewTestPaper {
  width: 180px;
  height: 50px;
  background: #349afe;
  border-radius: 10px;
  font-size: 26px;

  font-weight: 400;
  color: #ffffff;
  line-height: 26px;
}

.answerDetail {
  font-size: 18px;

  font-weight: 400;
  color: #1f96fa;
  line-height: 18px;
}

.score-inputFrame {
  margin-left: 9px;
  width: 50px;
  height: 24px;
  border: 1px solid #757575;
  border-radius: 5px;
}

.score-input {
  font-size: 18px;

  font-weight: 400;
  color: #349afe;
  width: 50px;
  height: 24px;
  border: 1px solid #757575;
  border-radius: 10px;
  text-align: center;
  background-color: transparent;
  border: 0px;
  outline: none;
}

.score-txt {
  font-size: 18px;

  font-weight: 400;
  color: #555555;
}

.resourceDetails-scoreBox {
  width: 297px;
}

.questionType {
  font-size: 18px;

  font-weight: 400;
  color: #999999;
  line-height: 18px;
}

.score-completedPersonnel {
  margin-left: 12px;
  font-size: 18px;

  font-weight: 400;
  color: #349afe;
}

.option-box {
  margin-top: 15px;
  border-left: 4px solid #dddddd;
}

.option-txt {
  margin-left: 15px;
  margin-top: 10px;
  font-size: 14px;

  font-weight: 400;
  color: #000000;
  line-height: 14px;
}

.option-txt:first-child {
  margin-top: 0;
  font-size: 14px;

  font-weight: 400;
  color: #000000;
  line-height: 14px;
}

.topic-answer {
  margin-top: 15px;
  font-size: 18px;

  font-weight: 400;
  color: #349afe;
  line-height: 18px;
}

.popup-shortAnswer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
}

.shortAnswer-content {
  position: relative;
  width: 1020px;
  background: #ffffff;
  border-radius: 20px;
  padding: 41px 80px 26px 80px;
  box-sizing: border-box;
}

.btnClose {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 23px;
  height: 23px;
}

.shortAnswer-typeBox {
  margin-top: 28px;
}

.shortAnswer-nameTxt {
  margin-top: 10px;
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 18px;
}

.shortAnswer-answerBox {
  margin-top: 14px;
  width: 860px;
  height: 140px;
  border: 1px solid #aaaaaa;
  border-radius: 10px;
  padding: 16px 21px;
  box-sizing: border-box;
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 25px;
  overflow: auto;
}

.shortAnswer-analysis {
  margin-top: 14px;
  font-size: 18px;

  font-weight: 400;
  color: #349afe;
  line-height: 25px;
}

.btnConfirm {
  margin-top: 20px;
  width: 200px;
  height: 50px;
  background: #349afe;
  border-radius: 10px;
  font-size: 28px;

  font-weight: 400;
  color: #ffffff;
  line-height: 28px;
}

.popup-testPaper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
}

.testPaper-content {
  position: relative;
  width: 1020px;
  height: 805px;
  background: #ffffff;
  border-radius: 20px;
  padding: 41px 30px 26px 30px;
  box-sizing: border-box;
}

.testPaperList-box {
  height: 723px;
  overflow: auto;
}

.testPaper-topicBox {
  padding: 20px 0px;
  border-bottom: 1px solid #bfbfbf;
  box-sizing: border-box;
}

.testPaper-typeBox {
  width: 100px;
  margin-left: 20px;
}

.examPaperDetails-typeBox {
  width: 84px;
}

.testPaper-topicNum {
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 18px;
}

.testPaper-topicType {
  font-size: 18px;

  font-weight: 400;
  color: #999999;
  line-height: 18px;
}

.testPaper-options {
  margin-left: 61px;
}

.examPaperDetails-options {
  margin-left: 26px;
}

.examPaperDetails-box {
  width: 1273px;
  height: calc(100vh - 87.48px - 140px);
  padding: 0 40px;
  box-sizing: border-box;
  overflow: auto;
}

.txtWidth {
  width: 60px;
  text-align: right;
}

.detailIcon {
  width: 106px;
  height: 18px;
}

// 查看数据弹窗
.popup-viewData {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
}

.viewData-content {
  width: 1659px;
  height: 800px;
  border: 1px solid #dddddd;
  background: #ffffff;
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
}

.btnClose {
  position: absolute;
  top: 24px;
  right: 24px;
}

.resourcesDetails-img {
  width: 500px;
  height: 281px;
  border-radius: 10px;
}
</style>
